<template>
  <b-container fluid="lg">
    <Header :date="date" @changedDate="changeMonth" />

    <div class="d-flex justify-content-end mb-3">
      <b-button
        v-if="hasAuth(['senior', 'admin'])"
        pill
        variant="secondary"
        :to="{ name: 'AddSchedule', params: { tutorId: $route.params.tutorId } }"
      >
        Add
      </b-button>
    </div>
    <Schedule :date="date" :timesheet="timesheet" />
    <div class="d-flex justify-content-end mb-3">
      <b-button
        v-if="isConfirmable"
        pill variant="primary"
        @click="closingConfirm"
      >
        Submit
      </b-button>
    </div>

    <div v-if="timesheet" class="timesheet-detail-summary">
      <WorkingTime :date="date" :workingTimes="timesheet.summary.workingTimes" class="mb-5" />
      <Other :date="date" :others="timesheet.summary.others" class="mb-5" />
      <div class="d-flex">
        <WorkingDay :date="date" :workingDays="timesheet.summary.workingDays" class="pr-2" />
        <PaidAbsentDay :date="date" :paidAbsentDay="timesheet.summary.paidAbsentDay" class="pl-2" />
      </div>
      <UnpaidAbsentDay :date="date" :unpaidAbsentDays="timesheet.summary.unpaidAbsentDays" />
    </div>

    <ErrorModal ref="errorModal" />
    <Loading :isLoading="isLoading"/>
    <ConfirmModal ref="confirmModal" isLoadingMode @ok="closing" />
  </b-container>
</template>

<script lang="ts">
import Vue from 'vue'
import moment, { Moment } from 'moment'
import _ from 'lodash'
import Header from '@/components/parts/timesheet/detail/Header.vue'
import Schedule from '@/components/parts/timesheet/detail/Schedule.vue'
import WorkingTime from '@/components/parts/timesheet/detail/WorkingTime.vue'
import Other from '@/components/parts/timesheet/detail/Other.vue'
import WorkingDay from '@/components/parts/timesheet/detail/WorkingDay.vue'
import UnpaidAbsentDay from '@/components/parts/timesheet/detail/UnpaidAbsentDay.vue'
import PaidAbsentDay from '@/components/parts/timesheet/detail/PaidAbsentDay.vue'
import ErrorModal from '@/components/parts/modal/Error.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import { Timesheet, TimesheetCloseParams } from '@/store/timesheets/types'
import ConfirmModal from '@/components/parts/modal/Confirm.vue';
import { RootState } from '@/store/types'

export default Vue.extend({
  components: {
    Header,
    Schedule,
    WorkingTime,
    Other,
    WorkingDay,
    UnpaidAbsentDay,
    PaidAbsentDay,
    ErrorModal,
    Loading,
    ConfirmModal,
  },

  data(): {
    date: Moment,
    isActive: boolean,
    isLoading: boolean,
    isFetchingTimesheet: boolean,
    } {
    return {
      date: moment().startOf('month'),
      isActive: true,
      isLoading: false,
      isFetchingTimesheet: false,
    }
  },

  created() {
    this.getTimesheet()
  },

  computed: {
    timesheet(): Timesheet|undefined {
      return this.$store.getters.findTimesheet({
        tutorId: this.$route.params.tutorId,
        yearMonth: this.date.format('YYYYMM'),
      })
    },
    /**
     * 月締めボタン表示判定
     */
    isConfirmable(): boolean {
      const auth = (this.$store.state as RootState).auth.profile
      if (_.indexOf(['tutor'], auth?.authority) === -1) return false
      if (auth?.id !== this.$route.params.tutorId) return false
      return this.timesheet?.isConfirmed === false
    },
  },

  methods: {
    /**
     * タイムシートの詳細情報取得
     */
    getTimesheet() {
      this.isLoading = true
      this.$store.dispatch(
        'getTimesheet',
        {
          tutorId: this.$route.params.tutorId,
          yearMonth: this.date.clone().format('YYYYMM'),
        },
      )
        .catch((error) => {
          const message = (_.has(error, 'resoponse'))
            ? _.get(error, 'response.data.message')
            : _.get(error, 'message');
          (this.$refs.errorModal as ErrorModal).open(message)
        })
        .finally(() => {
          this.isFetchingTimesheet = false
          this.isLoading = false
        })
    },
    /**
     * 月の移動
     * @param {Moment} date 移動対象月（Momentなので対象月の日付）
     */
    changeMonth(date: Moment) {
      this.date = date.clone()
      this.getTimesheet()
    },

    // 月締実行の確認
    closingConfirm() {
      (this.$refs.confirmModal as ConfirmModal)
        .open('Do you want to do a monthly close?');
    },
    // 月締
    closing() {
      this.isLoading = true;
      this.$store.dispatch('timesheetClose', {
        tutorId: this.$route.params.tutorId,
        yearMonth: Number(this.date.format('YYYYMM')),
      } as TimesheetCloseParams)
        .then(() => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk('Success !')
            .then(() => { this.$router.go(0) })
        })
        .catch((error) => {
          this.isLoading = false;
          const message = error.response?.data?.message || error;
          this.$bvModal.msgBoxOk(`Error - ${message}`);
        })
    },
    hasAuth(acceptRoles: string[]): boolean {
      const auth = (this.$store.state as RootState).auth.profile?.authority
      return _.indexOf(acceptRoles, auth) !== -1
    },
  },
})
</script>

<style scoped>
.add-button {
  background: #1cc8a0;
  border:3px solid #1cc8a0;
  color: #fff;
  border-radius: 30px;
  display: block;
  cursor: pointer;
  user-select:none;
}

.add-button:hover {
  background:#fff;
  color: #1cc8a0;
}
</style>
